module.exports = __webpack_public_path__ + "img/freek_09.049969a6.jpg";